// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchCell-cls1_UT4","cls2":"SearchCell-cls2_4bt SearchCell-cls1_UT4"};